<svelte:options tag={null} />

<script lang="ts">
  export let id: string;
  export let name: string;
  export let checked: boolean;
  export let disabled = false;
  export let isinvalid = false;
  export let label: string;

  $: userClass = $$props.class;
  $: attributes = { ...$$restProps };
  $: delete attributes.class;

  function getClasses(isInvalid: boolean): string {
    const classes = ['mc-radio__input'];
    if (isInvalid) {
      classes.push('is-invalid');
    }
    return classes.join(' ');
  }
</script>

<div class="mc-radio {userClass}" on:click {...attributes}>
  <input
    {id}
    type="radio"
    class={getClasses(isinvalid)}
    aria-invalid={isinvalid}
    {name}
    {checked}
    {disabled}
  />
  <label for={id} class="mc-radio__label">{label}</label>
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/c.radio';
</style>
